import { render, staticRenderFns } from "./StatisticCards.vue?vue&type=template&id=67483f0a&scoped=true"
import script from "./StatisticCards.vue?vue&type=script&lang=js"
export * from "./StatisticCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67483f0a",
  null
  
)

export default component.exports